import { MAX_DEMO_LIFE_PERIOD_IN_DAYS } from '../constants';
import getPassedDays from './getPassedDays';

export const checkAccountExpirationPeriod = (isLive, creationDate) => {
  const lifeTimeInDays = getPassedDays(creationDate);
  return !isLive && lifeTimeInDays > MAX_DEMO_LIFE_PERIOD_IN_DAYS;
};
